import '../competition-r41.css';
import {BonusMark} from './BonusBoardArt';
import MoveLetterIcon from './MoveLetterIcon';
const {isBonus}=require('../utils/competitionRules');
import DailyBadgeArt from './DailyBadgeArt';
const {botDifficultySuffix} = require('../utils/botDifficulty');
import './Duel.css';
import './Market.css';
import {CosmeticAvatar} from './CosmeticArt';
import useCosmetics from '../utils/useCosmetics';
import useGameViewportFit from '../hooks/useGameViewportFit';
import OpponentProfile from './OpponentProfile';
import KelimoLogo from './KelimoLogo';
import SettingsDialog from './SettingsDialog';
import { largeLettersEnabled } from './ReadabilitySettings';
import MatchTools from './MatchTools';
import useBackLayer from '../hooks/useBackLayer';
import React, { useEffect, useRef, useState, } from 'react';
import { Check, Delete, SkipForward } from 'lucide-react';
import OpponentFriendButton from './OpponentFriendButton';
import DualMatchClock from './DualMatchClock';
import GameChat, { GameChatButton } from './GameChat';
import { Home, ArrowLeft } from 'lucide-react';
import { playSoundEffect } from '../utils/soundEffects';
import useShowcasedBadge from '../utils/useShowcasedBadge';
import usePlayerDisplayName from '../utils/usePlayerDisplayName';
import { resolveAvatarUrl } from '../config/serverEndpoint';
import ProfileReportButton from './ProfileReportButton';

export default function GameScreen({

  socket, gameIdOverride, incomingPlacement, localGame = false, previewSnapshot = false, connectionReady = true, onRecover = () => {},
  turnData,
  turnDurationHours,
  clockSpec,
  botDifficulty,duel,
  board,
  setBoard,
  ownLetterDraft,
  validWordCells,
  scores,
  gameOverData,
  username,
  profileImage,
  opponentImage,
  opponentUsername, social, onFriendAction, friendActionError,
  setCurrentScreen, onBack,
  onRematch,
  isReconnect,
  chat = { messages: [], unread: 0 }, chatGameId, onChatGet, onChatOlder, onChatSend, onChatRead, onChatReport
}) {
  const viewportRoot = useRef(null);
  useGameViewportFit(viewportRoot);

const [jokerSelection,setJokerSelection]=useState(null);
const [jokerPending,setJokerPending]=useState(false);
const jokerRequest=useRef(null);
const joker=turnData?.joker;
const bonusGame=!localGame&&board.length===8&&turnData?.rulesVersion===41;
useEffect(()=>{setJokerSelection(null);setJokerPending(false);jokerRequest.current=null;},[gameIdOverride,turnData?.joker?.turnKey]);
useEffect(()=>{const receive=e=>{if(e.detail.requestId!==jokerRequest.current)return;setJokerPending(false);setJokerSelection(null);setMessage(e.detail.ok?'Harf taşındı.':e.detail.message);if(e.detail.ok)window.dispatchEvent(new Event('kelimo-coins-updated'));};window.addEventListener('kelimo-joker-result',receive);return()=>window.removeEventListener('kelimo-joker-result',receive);},[]);
useEffect(()=>{if(!jokerPending)return;const id=setTimeout(()=>{setJokerPending(false);setJokerSelection(null);recoverRef.current({reason:'joker-ack-timeout'});},8000);return()=>clearTimeout(id);},[jokerPending]);
useBackLayer(Boolean(jokerSelection)&&!jokerPending,()=>setJokerSelection(null));
const [selectedCell, setSelectedCell] = useState(null);
const [enteredLetter, setEnteredLetter] = useState('');
const [tempPosition, setTempPosition] = useState(null);
const [message, setMessage] = useState('');
const [chatOpen, setChatOpen] = useState(false);
const [forfeitOpen, setForfeitOpen] = useState(false);
const [opponentProfileOpen,setOpponentProfileOpen]=useState(false);
const [ownProfileOpen,setOwnProfileOpen]=useState(false);
useBackLayer(ownProfileOpen,()=>setOwnProfileOpen(false));
useBackLayer(opponentProfileOpen,()=>setOpponentProfileOpen(false));
useBackLayer(forfeitOpen, () => setForfeitOpen(false));
  useBackLayer(Boolean(chatOpen), () => setChatOpen(false));

const [wideChat, setWideChat] = useState(() => window.matchMedia('(min-width: 1200px)').matches);
const humanChat = String(opponentUsername || '').toLocaleLowerCase('tr-TR') !== 'bilgisayar';
const ownDisplayName = usePlayerDisplayName(username, 'Sen');
const opponentDisplayName = usePlayerDisplayName(opponentUsername);
const opponentBadge = useShowcasedBadge(opponentUsername);
const myBadge = useShowcasedBadge(username);
useEffect(() => {
  const media = window.matchMedia('(min-width: 1200px)');
  const sync = () => setWideChat(media.matches);
  media.addEventListener('change', sync);
  return () => media.removeEventListener('change', sync);
}, []);
useEffect(() => { if (chatGameId) onChatGet?.(); }, [chatGameId]);

// Server-authoritative draft from another device of the same account.
// Replace local preview state; never layer the remote draft on top of a stale local one.
useEffect(() => {
  if (ownLetterDraft?.letter && Number.isInteger(ownLetterDraft.row) && Number.isInteger(ownLetterDraft.col)) {
    setEnteredLetter(ownLetterDraft.letter);
    setTempPosition({ row: ownLetterDraft.row, col: ownLetterDraft.col });
    setSelectedCell({ row: ownLetterDraft.row, col: ownLetterDraft.col });
    setSelectedLetter(null);
  } else if (ownLetterDraft === null) {
    setEnteredLetter('');
    setTempPosition(null);
    setSelectedCell(null);
    setSelectedLetter(null);
  }
}, [ownLetterDraft]);

useEffect(() => {
    if (isReconnect) {
      setMessage('⏪ Kaldığın yerden devam ediyorsun.');
      const timer = setTimeout(() => setMessage(''), 3000);
      return () => clearTimeout(timer);
    }
  }, [isReconnect]);

const [turnInfo, setTurnInfo] = useState('');
const [timer, setTimer] = useState('');
const timerRef = useRef(null);
const [isMyTurn, setIsMyTurn] = useState(previewSnapshot ? Boolean(turnData?.yourTurn) : false);
const [largeLetters, setLargeLetters] = useState(() => largeLettersEnabled(username));
useEffect(() => { const sync = () => setLargeLetters(largeLettersEnabled(username)); sync(); window.addEventListener('kelimo-readability-updated', sync); window.addEventListener('storage', sync); return () => { window.removeEventListener('kelimo-readability-updated', sync); window.removeEventListener('storage', sync); }; }, [username]);
const [letterToPlace, setLetterToPlace] = useState(previewSnapshot ? turnData?.letterToPlace||null : null);
const [confirmPending, setConfirmPending] = useState(false);
const buttonsDisabled = !connectionReady || confirmPending || !isMyTurn || letterToPlace !== null;
useEffect(() => { setConfirmPending(false); }, [turnData]);
const recoverRef = useRef(onRecover); recoverRef.current = onRecover;
useEffect(() => { if (!confirmPending) return; const timeout = setTimeout(() => { setConfirmPending(false); setMessage(localGame?'Hamle durumu yeniden alınıyor…':'Hamle durumu sunucudan yeniden alınıyor…'); recoverRef.current({reason:'move-ack-timeout'}); }, 8000); return () => clearTimeout(timeout); }, [confirmPending]);
const gameConnectionReady = () => connectionReady && !confirmPending && socket?.readyState === WebSocket.OPEN && socket.authenticated !== false && (socket.bufferedAmount || 0) < 65536;
const draftReady = !buttonsDisabled && Boolean(selectedCell && enteredLetter && tempPosition);
const [confirmReminder, setConfirmReminder] = useState(false);
useEffect(() => {
  setConfirmReminder(false);
  if (!draftReady) return;
  const timer = setTimeout(() => setConfirmReminder(true), 5000);
  return () => clearTimeout(timer);
}, [draftReady, tempPosition?.row, tempPosition?.col, enteredLetter]);
const canPassIncomingLetter = isMyTurn && letterToPlace !== null;

const [gameStartedBefore, setGameStartedBefore] = useState(false);
const [selectedLetter, setSelectedLetter] = useState(null);
const [incomingEditable, setIncomingEditable] = useState(incomingPlacement || null);
useEffect(()=>{if(incomingPlacement!==undefined)setIncomingEditable(incomingPlacement);},[incomingPlacement]);
const [incomingMoveArmed, setIncomingMoveArmed] = useState(false);
// useState'leri component üstüne ekle
const [previewLetter, setPreviewLetter] = useState(null);         // Basılan harf
const [previewPosition, setPreviewPosition] = useState({ x: 0, y: 0 }); // Parmağın ekran pozisyonu
const letterRefs = useRef([]); // Tüm harf kutularını takip etmek için ref dizisi
const isMenuButtonDisabled = false;

const cosmetics=useCosmetics(username);
const opponentCosmetics=useCosmetics(opponentUsername);
const fullProfileImage = resolveAvatarUrl(profileImage || '/default-avatar.png');

  const fullOpponentImage = resolveAvatarUrl(opponentImage || '/default-avatar.png');

const startTimer = (duration, turn) => {
  if (timerRef.current) clearInterval(timerRef.current);

  const deadline = Number(turn?.turnStartTime) > 0
    ? Number(turn.turnStartTime) + Number(duration)
    : Date.now() + Number(duration);
  let timeLeft = Math.max(0, deadline - Date.now());
  const warningKey = `kelimoTimeWarning:${username}:${gameIdOverride || sessionStorage.getItem('gameId') || ''}`;
  const warnIfNeeded = () => {
    if (!turn?.yourTurn || !turn.turnStartTime || document.visibilityState !== 'visible' || timeLeft <= 0 || timeLeft > 5 * 60 * 1000) return;
    const turnId = String(turn.turnStartTime);
    if (window.localStorage.getItem(warningKey) === turnId) return;
    window.localStorage.setItem(warningKey, turnId);
    playSoundEffect('timeWarning');
  };

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (totalSeconds <= 0) return '⏰ Süre doldu';
    
     // Saatlik gösterim (1 saatten fazla ise)
  if (totalSeconds >= 3600) {
    // Örneğin 5 saat 15 dakika varsa → "6 saat" göstermeliyiz
    const roundedHour = Math.ceil(totalSeconds / 3600);
    return `${roundedHour} saat`;
  }

  // 1 dakika ile 59 dakika arası
  if (totalSeconds >= 60) {
    return `${minutes} dakika`;
  }

  // Son dakika: Dakika:saniye formatı
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
  // İlk gösterim
  setTimer(formatTime(timeLeft));
  warnIfNeeded();

  timerRef.current = setInterval(() => {
    timeLeft = Math.max(0, deadline - Date.now());
    warnIfNeeded();

    setTimer(formatTime(timeLeft));

    if (timeLeft <= 0) {
      clearInterval(timerRef.current);
      timerRef.current = null;
      setTimer('⏰ Süre doldu');
      if (turn?.yourTurn) setMessage('⏰ Hamle süren sona erdi.');
      setTurnInfo('');
    }
  }, 1000);
};
const stopTimer = () => {
  if (timerRef.current) {
    clearInterval(timerRef.current);
    timerRef.current = null;
  }

  setTimer(''); // ⬅️ DOM'a değil, state'e yazıyoruz
};


const handleCellClick = (row, col) => {
  if(jokerPending)return;
  if(jokerSelection){if(!gameConnectionReady()||!isMyTurn){setJokerSelection(null);return;}if(!jokerSelection.from){if(!board[row][col]){setMessage('Taşımak için dolu bir hücre seç.');return;}setJokerSelection({from:{row,col}});setMessage('Şimdi boş hedef hücreyi seç.');}else if(board[row][col]){setJokerSelection({from:{row,col}});}else setJokerSelection(s=>({...s,to:{row,col}}));return;}

  if (!gameConnectionReady()) { setMessage('Bağlantı hazır değil; hamlen gönderilmedi.'); return; }
// 🛑 Eğer sıra sende değilse ve rakipten gelen harf de yoksa, tıklama iptal
if (!isMyTurn && !letterToPlace) {
  playSoundEffect('error');
  setMessage('Şu an hamle sırası sende değil!');
  return;
}

    const cellValue = board[row][col];

    // Incoming taş, own-letter draft yerleştirilmiş olsa bile Onayla'ya kadar seçilebilir.
    // Board hücresinin lokal render değeri burada otorite değildir; koordinatı incomingEditable belirler.
    if (incomingEditable &&
        incomingEditable.row === row && incomingEditable.col === col) {
      setIncomingMoveArmed(true);
      setMessage(`Rakipten gelen "${incomingEditable.letter}" harfi seçildi. Yeni boş hücreye dokun.`);
      return;
    }

    if (cellValue !== '') {
      playSoundEffect('error');
      setMessage('Bu hücre dolu ve kalıcı, değiştiremezsin!');
      return;
    }

    if (incomingEditable && incomingMoveArmed) {
      const newBoard = board.map(r => [...r]);
      newBoard[incomingEditable.row][incomingEditable.col] = '';
      newBoard[row][col] = incomingEditable.letter;
      setBoard(newBoard);
      socket.send(JSON.stringify({
        type: 'relocateOpponentLetter',
        oldRow: incomingEditable.row, oldCol: incomingEditable.col,
        row, col
      }));
      setIncomingEditable({ ...incomingEditable, row, col });
      setIncomingMoveArmed(false);
      playSoundEffect('place');
      setMessage(`Rakipten gelen "${incomingEditable.letter}" harfi yeni konuma taşındı.`);
      return;
    }

    const clicked = { row, col };

    if (letterToPlace) {
    const newBoard = board.map(r => [...r]);
    newBoard[row][col] = letterToPlace;
    setBoard(newBoard);
    socket.send(JSON.stringify({ type: 'placeOpponentLetter', row, col }));
    playSoundEffect('place');
    setMessage(`Rakibin harfi "${letterToPlace}" konumuna yerleştirildi.`);
    setIncomingEditable({ letter: letterToPlace, row, col });
    setIncomingMoveArmed(false);
    setLetterToPlace(null);
    // Rakipten gelen taş yerleştirildikten sonra önceki hücre/harf seçimini taşımayız.
    // Böylece harf paleti yalnızca bundan sonra seçilecek kendi harfini etkiler.
    setSelectedCell(null);
    setSelectedLetter(null);
    setEnteredLetter('');
    setTempPosition(null);
    return;
  }
  // 1️⃣ Önce eski preview’i sil
    const newBoard = board.map(r => [...r]);
    if (tempPosition) {
        newBoard[tempPosition.row][tempPosition.col] = '';
    }

  if (selectedLetter) {
    setEnteredLetter(selectedLetter);
    setTempPosition(clicked);
    setSelectedCell(clicked);

    newBoard[row][col] = selectedLetter; // yeni preview
    setBoard(newBoard);
    setSelectedLetter(null);

    playSoundEffect('place');
    setMessage(`"${selectedLetter}" harfi seçilen kutuya yerleştirildi.`);
    if (socket?.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({
        type: 'updateOwnLetterPlacement',
        letter: selectedLetter,
        row, col,
        ...(tempPosition ? { oldRow: tempPosition.row, oldCol: tempPosition.col } : {})
      }));
    }
    return;
  }

    if (tempPosition && enteredLetter) {
      if (tempPosition.row !== row || tempPosition.col !== col) {
        setSelectedCell(clicked);
        setTempPosition(clicked);
        playSoundEffect('place');
    setMessage(`Harf (${enteredLetter}) yeni konuma taşındı.`);


        newBoard[row][col] = enteredLetter; // yeni preview
        setBoard(newBoard);
      }
    } else {
      setSelectedCell(clicked);
      setEnteredLetter(board[row][col] || '');
      setMessage('Hücre seçildi. Klavyeden harf girin.');
    }
};

// 🧠 Klavye dinleyici
useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedCell || letterToPlace) return;

      const rawKey = e.key;
      const letter = e.key.toLocaleUpperCase('tr-TR');
      if (forbiddenLetters.includes(letter)) {
      e.preventDefault();
      playSoundEffect('error');
      setMessage(`"${letter}" harfi kullanılamaz.`);
      return;
    }
      if (!/^[A-ZÇĞİÖŞÜ]$/.test(letter)) return;

      // Önceki preview’i sil
        if (tempPosition) {
            const newBoard = board.map(r => [...r]);
            const { row: prevRow, col: prevCol } = tempPosition;
            newBoard[prevRow][prevCol] = '';
            setBoard(newBoard);
        }

      setEnteredLetter(letter);
      setTempPosition({ row: selectedCell.row, col: selectedCell.col });

      const newBoard = board.map(r => [...r]);
      newBoard[selectedCell.row][selectedCell.col] = letter;
      setBoard(newBoard);

      playSoundEffect('place');
    setMessage(`"${letter}" harfi geçici olarak seçilen kutuya yerleştirildi.`);

      if (socket?.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({
          type: 'updateOwnLetterPlacement',
          letter,
          row: selectedCell.row,
          col: selectedCell.col,
          ...(tempPosition ? { oldRow: tempPosition.row, oldCol: tempPosition.col } : {})
        }));
      }

      if (e.key === 'Enter') {
  e.preventDefault();
  confirmOwnLetter(); // 👈 Enter’a basıldığında harfi sunucuya gönder
}

    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
}, [selectedCell, tempPosition, enteredLetter, board, socket]);

// ⬇️ State'lerin altına ekle (örn. const [message, setMessage] = useState(''); varsa onun altı)
const updateTurnMessages = (yourTurn, letterToPlace) => {
  if (yourTurn && letterToPlace) {
    setMessage('Harfi klavyeden girip boş bir hücreye yerleştir.');
    setTurnInfo('Rakipten gelen harfi yerleştir.');
  } else if (yourTurn && !letterToPlace) {
    setMessage('');
    setTurnInfo('Kendi harfini girip yerleştir.');
  } else if (!yourTurn && letterToPlace) {
    setMessage(`Rakibin gönderdiği harf: "${letterToPlace}"`);
    setTurnInfo('Bu harfi uygun kutuya yerleştir.');
  } else {
    setMessage('');
    setTurnInfo('Rakibin hamlesi bekleniyor...');
  }
};
const handleCellDrop = (row, col, e) => {
  if (!gameConnectionReady()) { e.preventDefault(); return; }
  e.preventDefault();
  const letter = e.dataTransfer.getData('text/plain');

  if (!letter || !isMyTurn) {
    playSoundEffect('error');
    setMessage('Sıra sende değil ya da geçersiz harf.');
    return;
  }

  if (letterToPlace) {
    // Rakipten gelen harfi yerleştiriyoruz
    const newBoard = board.map(r => [...r]);
    if (newBoard[row][col] !== '') {
      playSoundEffect('error');
      setMessage('Bu kutu dolu!');
      return;
    }

    const incomingLetter = letterToPlace;
    newBoard[row][col] = incomingLetter;
    setBoard(newBoard);

    socket.send(JSON.stringify({ type: 'placeOpponentLetter', row, col }));
    playSoundEffect('place');
    setIncomingEditable({ letter: incomingLetter, row, col });
    setIncomingMoveArmed(false);
    setSelectedCell(null);
    setSelectedLetter(null);
    setLetterToPlace(null);
    setMessage(`Rakip harfi "${incomingLetter}" konumuna yerleştirildi.`);
    return;
  } else {
    // Kendi seçtiğimiz harf
    const newBoard = board.map(r => [...r]);
    if (newBoard[row][col] !== '') {
      setMessage('Bu kutu dolu!');
      return;
    }

    newBoard[row][col] = letter;
    setBoard(newBoard);
    setEnteredLetter(letter);
    setTempPosition({ row, col });
    setSelectedCell({ row, col });
    playSoundEffect('place');
    setMessage(`"${letter}" harfi seçilen kutuya yerleştirildi.`);
  }
};

const handleLetterClick = (letter) => {
  // Rakipten gelen taş taşınmak üzere seçildiyse harf paleti onun değerini değiştiremez.
  if (letterToPlace !== null || incomingMoveArmed) return;

  // Mobilde hücre → harf sırası da tek dokunuşta yerleştirsin.
  const selectedCellIsOwnDraft = Boolean(
    selectedCell && tempPosition &&
    selectedCell.row === tempPosition.row && selectedCell.col === tempPosition.col
  );
  if (selectedCell && (board[selectedCell.row][selectedCell.col] === '' || selectedCellIsOwnDraft)) {
    const newBoard = board.map(r => [...r]);
    if (tempPosition) newBoard[tempPosition.row][tempPosition.col] = '';
    newBoard[selectedCell.row][selectedCell.col] = letter;
    setBoard(newBoard);
    setEnteredLetter(letter);
    setTempPosition({ row: selectedCell.row, col: selectedCell.col });
    setSelectedLetter(null);
    playSoundEffect('place');
    setMessage(`"${letter}" harfi seçilen kutuya yerleştirildi.`);
    if (socket?.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({
        type: 'updateOwnLetterPlacement',
        letter,
        row: selectedCell.row,
        col: selectedCell.col,
        ...(tempPosition ? { oldRow: tempPosition.row, oldCol: tempPosition.col } : {})
      }));
    }
  } else {
    setSelectedLetter(letter);
  }
};


// 💬 [YENİ] İlk render'da mesajları önceden göster
useEffect(() => {
  if (!turnData) {
    setMessage('Oyun başlıyor...');
    setTurnInfo('Rakibin hamlesi bekleniyor...');
  }
}, []);

useEffect(() => {

  if (isMyTurn && !letterToPlace && tempPosition && enteredLetter && !ownLetterDraft) {
    setBoard(prev => {
      const newBoard = prev.map(r => [...r]);
      newBoard[tempPosition.row][tempPosition.col] = enteredLetter;
      return newBoard;
    });
  }
}, [isMyTurn, letterToPlace, tempPosition, enteredLetter, ownLetterDraft]);

useEffect(() => {
  
if (!turnData) return;

const yourTurn = turnData.yourTurn ?? false;
const letterToPlace = turnData.letterToPlace ?? null;

setIsMyTurn(yourTurn);
setLetterToPlace(letterToPlace);

updateTurnMessages(yourTurn, letterToPlace);

stopTimer(); // Önceki süreyi temizle

if (!turnData.clocks && turnData.turnDuration) {
    startTimer(turnData.turnDuration, turnData);
  }


return () => {
  stopTimer(); // Component unmount edildiğinde de timer'ı durdur
 };
}, [turnData]);

useEffect(() => {
    updateTurnMessages(isMyTurn, letterToPlace);
  }, [isMyTurn, letterToPlace]);

useEffect(() => {
  if (turnData && !ownLetterDraft?.letter) {
    setSelectedCell(null);
    setEnteredLetter('');
    setTempPosition(null);
  }
}, [turnData]);

const forbiddenLetters = ['X', 'W', 'Q'];

const handleVoluntaryPass = () => {
  if (!canPassIncomingLetter || !gameConnectionReady()) {
    setMessage('Pas yalnızca rakipten gelen harfi yerleştirme aşamasında kullanılabilir.');
    return;
  }

  socket.send(JSON.stringify({ type: 'voluntaryPass' }));
  playSoundEffect('pass');
  setMessage('Pas isteği gönderildi...');
};

const confirmOwnLetter = () => {
  if (!gameConnectionReady()) { setMessage('Bağlantı hazır değil; hamlen gönderilmedi.'); onRecover({reason:'move-connection-unready'}); return; }
  const telemetry = (event, extra = {}) => {
    if (socket?.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({
        type: 'clientTelemetry', event,
        gameId: sessionStorage.getItem('gameId') || null,
        username,
        yourTurn: turnData?.yourTurn ?? null,
        letterToPlace: letterToPlace ?? null,
        selectedCell,
        enteredLetter,
        tempPosition,
        clientTs: new Date().toISOString(),
        ...extra
      }));
    }
  };
  telemetry('CONFIRM_OWN_CLICK');
  if (!turnData?.yourTurn || letterToPlace !== null) {
    playSoundEffect('error');
    telemetry('CONFIRM_OWN_BLOCKED', { reason: 'turn_guard' });
    setMessage('Sıra sende değil ya da hala rakip harfini yerleştirmedin.');
    return;
  }

  if (!selectedCell || !enteredLetter || !tempPosition) {
    playSoundEffect('error');
    setMessage('Harf girişi eksik.');
    return;
  }

  if (forbiddenLetters.includes(enteredLetter.toUpperCase())) {
    playSoundEffect('error');
    setMessage(`"${enteredLetter.toUpperCase()}" harfi kullanılamaz.`);
    return;
  }
  setConfirmPending(true);
  // 🛑 Süreyi durdur
  stopTimer();

  // 🔧 ŞU ŞEKİLDE GÖNDER:
  socket.send(JSON.stringify({
    type: 'updateOwnLetterPlacement',
    letter: enteredLetter,
    row: tempPosition.row,
    col: tempPosition.col
  }));

  socket.send(JSON.stringify({
    type: 'placeOwnLetter', 
    }));
  telemetry('CONFIRM_OWN_MESSAGES_SENT');
  playSoundEffect('confirm');

  setMessage(`Harf yerleştirildi: ${enteredLetter.toUpperCase()} (${tempPosition.row}, ${tempPosition.col})`);
  setEnteredLetter('');
  setTempPosition(null);
  setSelectedCell(null);
  setSelectedLetter(null);
  setIncomingEditable(null);
  setIncomingMoveArmed(false);
  updateTurnMessages(false, null);
};

const secondsLeft = parseInt(timer);
useEffect(() => {
  if (!turnData && !gameStartedBefore) {
    setMessage('🎯 İlk harfler geliyor... Hazır ol!');
    setGameStartedBefore(true);
  }
}, [turnData, gameStartedBefore]);

useEffect(() => {
  letterRefs.current = []; // Her render'da sıfırlanmalı
}, [/* harf havuzu değiştiğinde (genellikle sabit olduğu için boş bırakabilirsin) */]);

const clearOwnDraft = () => {
    if (!isMyTurn || letterToPlace !== null || incomingMoveArmed || socket?.readyState !== WebSocket.OPEN) return;
    if (!tempPosition) {
      setMessage('Silinecek geçici harf yok.');
      return;
    }

    const newBoard = board.map(r => [...r]);
    newBoard[tempPosition.row][tempPosition.col] = '';
    setBoard(newBoard);

    setEnteredLetter('');
    setTempPosition(null);
    setSelectedCell(null);
    setSelectedLetter(null);

    socket.send(JSON.stringify({
      type: 'updateOwnLetterPlacement',
      letter: '',
      row: tempPosition.row,
      col: tempPosition.col,
      oldRow: tempPosition.row,
      oldCol: tempPosition.col
    }));

    setMessage('Son harf geri alındı.');
};

return (
<>
<div ref={viewportRoot} data-human-chat={humanChat ? 'true' : 'false'} className="kelimo-game fixed inset-0 flex min-h-[100dvh] w-full flex-col overflow-y-auto overscroll-none bg-gradient-to-b from-slate-200 via-indigo-200 to-violet-300">

{previewLetter && (
  <div
    className="fixed z-50 pointer-events-none"
    style={{
      top: previewPosition.y - 90, // ⬅️ -60 yerine -90 veya -100 yap
  left: previewPosition.x - 30,
    }}
  >
    <div className="min-w-[60px] px-4 h-16 rounded-xl bg-white border border-gray-300 shadow-xl flex items-center justify-center text-4xl font-extrabold text-gray-900 scale-110 transition transform duration-75 ease-out">
      {previewLetter}
    </div>
  </div>
)}

{/* Kompakt maç başlığı */}
<header className="game-header relative z-40 shrink-0 border-b border-indigo-200 bg-indigo-50/95 px-3 py-2 text-slate-900 shadow-sm backdrop-blur-xl sm:px-5">
 <div className="game-top"><button type="button" onClick={onBack} aria-label="Oyunlarıma dön"><ArrowLeft size={24}/></button><div className="page-brand-title"><KelimoLogo/><h1 className="sr-only">Oyun içi</h1></div><MatchTools compact onHome={() => { setCurrentScreen('start'); if (socket?.readyState === WebSocket.OPEN) socket.send(JSON.stringify({ type: 'minimizeGame' })); }} onForfeit={() => setForfeitOpen(true)}><OpponentFriendButton social={social} username={username} opponent={opponentUsername} send={onFriendAction} error={friendActionError}/><ProfileReportButton username={username} target={opponentUsername}/></MatchTools></div>

 <div className="game-player-strip mx-auto grid w-full max-w-6xl grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-1.5 sm:gap-3">
  <div className="flex min-w-0 items-center gap-1.5 sm:gap-2.5">

    <button type="button" className="game-own-avatar-r9 relative shrink-0" aria-label="Profilimi aç" onClick={()=>setOwnProfileOpen(true)} title={myBadge || undefined}>{cosmetics.frame||cosmetics.avatar?<CosmeticAvatar active={cosmetics} photo={fullProfileImage} size={48}/>:<img
      src={fullProfileImage}
      alt="Sen"
      className="h-8 w-8 shrink-0 rounded-full border-2 border-emerald-400 object-cover sm:h-11 sm:w-11"
    />}{myBadge && <span aria-label={`Sergilenen rozet: ${myBadge}`} className="game-earned-badge absolute -bottom-1 -right-1 rounded-full border border-white bg-amber-400 px-0.5 text-xs leading-4"><DailyBadgeArt name={myBadge}/></span>}</button>
    <div className="min-w-0 text-left leading-tight">
      <p className="max-w-[18vw] truncate text-xs font-semibold text-slate-700 sm:max-w-none sm:text-sm">{ownDisplayName}</p>
      <p className="text-lg font-black text-emerald-600 sm:text-xl">{scores.myScore}</p>
    </div>
  </div>

  <div className="text-center leading-tight">
    <p className="whitespace-nowrap text-xs font-extrabold leading-4 text-indigo-700 sm:text-sm">{board.length}×{board.length} · {clockSpec?.version === 2 ? (clockSpec.preset === '12h' ? '12 sa / kişi' : `${clockSpec.preset} dk`) : (turnDurationHours === 12 || turnDurationHours === 72 ? `${turnDurationHours} sa / tur` : "Süre bilgisi yok")}{botDifficultySuffix(botDifficulty)} · {localGame||!humanChat?'Antrenman':turnData?.matchMode==='rated'?'Rated':'Casual'}</p>{duel&&<p className="duel-game-line"><span>Düello · {duel.wins[username]}–{duel.wins[opponentUsername]}</span><span>{duel.duelRound||duel.rounds.length+1}. maç</span></p>}
    {clockSpec?.version === 2 && <DualMatchClock headerLayout clocks={turnData?.clocks} preset={clockSpec.preset} username={username} gameId={chatGameId} isMyTurn={isMyTurn} letterToPlace={letterToPlace} compact />}
  </div>

  <div className="flex min-w-0 items-center justify-end gap-1.5 sm:gap-2.5">
    <div className="min-w-0 text-right leading-tight">
      <p className="max-w-[18vw] truncate text-xs font-semibold text-slate-700 sm:max-w-none sm:text-sm">{opponentDisplayName}</p>
      <p className="text-lg font-black text-indigo-600 sm:text-xl">{scores.opponentScore}</p>
    </div>
    <button type="button" className="opponent-avatar-button relative shrink-0" title={opponentBadge || undefined} disabled={!humanChat} aria-label="Rakibin profilini aç" onClick={()=>setOpponentProfileOpen(true)}>{opponentCosmetics.frame||opponentCosmetics.avatar?<CosmeticAvatar active={opponentCosmetics} photo={fullOpponentImage} size={48}/>:<img
      src={fullOpponentImage}
      alt="Rakip"
      className="h-8 w-8 shrink-0 rounded-full border-2 border-indigo-400 object-cover sm:h-11 sm:w-11"
    />}{opponentBadge && <span aria-label={`Sergilenen rozet: ${opponentBadge}`} className="game-earned-badge absolute -bottom-1 -right-1 rounded-full border border-white bg-amber-400 px-0.5 text-xs leading-4"><DailyBadgeArt name={opponentBadge}/></span>}</button>
  </div>
</div>
</header>

<main className={`mx-auto flex w-full max-w-[1450px] flex-col px-2 py-2 sm:px-5 sm:py-4 min-[900px]:grid min-[900px]:flex-1 min-[900px]:grid-cols-[minmax(360px,540px)_minmax(300px,420px)] min-[900px]:items-center min-[900px]:justify-center min-[900px]:gap-8 ${humanChat ? 'min-[1200px]:grid-cols-[minmax(360px,540px)_minmax(260px,380px)_minmax(260px,320px)]' : 'min-[1200px]:grid-cols-[minmax(360px,540px)_minmax(300px,420px)]'} min-[1200px]:gap-4`}>
 <section className="flex min-w-0 flex-col items-center">
{clockSpec?.version !== 2 && (
<div className="grid w-full max-w-[540px] grid-cols-[1fr_auto_1fr] items-center gap-2 rounded-2xl border border-slate-200 bg-white/90 p-2 shadow-md backdrop-blur-md sm:p-3">
  <div className="flex min-w-0 flex-col items-start">
    <p className="mb-0.5 text-[10px] font-bold uppercase tracking-wider text-slate-500 sm:text-xs">{isMyTurn ? 'Senin süren' : 'Rakibin süresi'}</p>
    <div
      className={`flex h-8 min-w-[82px] items-center justify-center rounded-lg border px-2 text-sm font-extrabold shadow-sm sm:h-10 sm:min-w-[104px] sm:text-base
        ${timer.includes('saat')
        ? 'bg-green-100 text-green-700 border-green-200'
        : timer.includes('dakika')
        ? 'bg-yellow-100 text-yellow-700 border-yellow-200'
        : timer.includes(':')
        ? 'bg-red-100 text-red-600 border-red-200 animate-pulse'
        : 'bg-gray-200 text-gray-500 border-gray-300'}
    `}
    >
      {timer || '-'}
    </div>
  </div>

  <div className={`rounded-full px-3 py-1 text-center text-xs font-extrabold sm:text-sm ${isMyTurn ? 'bg-emerald-400 text-emerald-950' : 'bg-indigo-400 text-indigo-950'}`}>
    {isMyTurn ? 'Sıra sende' : 'Rakipte'}
  </div>

  <div className="flex min-w-0 flex-col items-end">
    <p className="mb-0.5 text-[10px] font-bold uppercase tracking-wider text-slate-500 sm:text-xs">Gelen harf</p>
    <div className="flex h-8 min-w-[56px] items-center justify-center rounded-lg border border-indigo-200 bg-indigo-50 px-3 text-base font-black text-indigo-700 shadow-sm sm:h-10 sm:min-w-[72px] sm:text-lg">
      {letterToPlace ? (
        <span className="leading-none">
          {letterToPlace}
          </span>
      ) : (
        <span className="text-gray-400 text-xl">-</span>
      )}
    </div>
  </div>
</div>

)}
    {bonusGame&&<div className="joker-controls-r41"><button type="button" disabled={!connectionReady||confirmPending||jokerPending||!isMyTurn||joker?.placementStarted||Boolean(tempPosition)||Boolean(incomingEditable)||!joker?.inventory||joker?.used>=3||joker?.usedThisTurn} onClick={()=>{setJokerSelection({});setMessage('Taşıyacağın harfi seç.');}}><MoveLetterIcon size={32}/>Harf Taşıma · {joker?.inventory||0}</button><span>Sen: {Math.max(0,3-(joker?.used||0))}/3 · Rakip: {Math.max(0,3-(joker?.opponentUsed||0))}/3</span>{jokerSelection&&<button type="button" disabled={jokerPending} onClick={()=>{setJokerSelection(null);setMessage('');}}>Vazgeç</button>}</div>}
    <div className="game-incoming game-phase-card"  role="status" data-phase={letterToPlace ? 'incoming' : !isMyTurn ? 'waiting' : draftReady ? 'ready' : 'own'}>
      <span className="incoming-tile"><span>{letterToPlace || (draftReady ? '✓' : !isMyTurn ? '…' : selectedLetter || enteredLetter || '＋')}</span></span>
      <span><b>{letterToPlace ? 'Gelen harf' : !isMyTurn ? 'Rakip oynuyor' : draftReady ? 'Hamlen hazır' : 'Kendi harfini seç'}</b><small>{letterToPlace ? 'Boş bir hücreye dokun' : !isMyTurn ? 'Rakibinin hamlesini bekliyorsun' : draftReady ? 'Onayla’ya bas' : incomingMoveArmed ? 'Gelen harfin yeni yerini seç' : incomingEditable ? `${incomingEditable.letter} yerleştirildi · Kendi harfini seç` : 'Harfini seç ve tahtaya yerleştir'}</small></span>
    </div>

{/* Harf Havuzu - Q Klavye 3 Satır */}
    {/* Tahta Başlığı */}
    <div className="w-full text-center">

      {/* Oyun Tahtası */}
<div data-km-tile={cosmetics.tile||undefined} data-km-board={cosmetics.board||undefined} className={`km-material-board game-board relative mx-auto max-w-[440px] sm:w-[min(62vw,440px)] min-[900px]:w-full ${board.length > 5 ? 'w-[min(96vw,440px)]' : 'w-[min(88vw,45dvh)] min-w-[270px]'}`}>
  {/* Kare oran yaratıcı div */}
  <div className="pt-[100%]"></div>

  {/* Dış çerçeve - eski görünüm */}
  <div className="absolute inset-0 rounded-2xl border-2 border-slate-400 bg-slate-500 p-1.5 shadow-xl shadow-slate-400/30 sm:p-2">
    <div className="grid h-full w-full gap-[1%]" style={{ gridTemplateColumns: `repeat(${board.length}, minmax(0, 1fr))`, gridTemplateRows: `repeat(${board.length}, minmax(0, 1fr))` }}>
      {board.map((row, rowIndex) =>
        row.map((cell, colIndex) => {
          const isValidWordCell = Array.isArray(validWordCells) && validWordCells.some(
            (position) => position.row === rowIndex && position.col === colIndex
          );
          const isOwnLetterDraftCell = Boolean(
            (tempPosition?.row === rowIndex && tempPosition?.col === colIndex) ||
            (ownLetterDraft &&
              ownLetterDraft.row === rowIndex &&
              ownLetterDraft.col === colIndex)
          );
          const isCommittedLetterCell = Boolean(cell) && !isOwnLetterDraftCell;
          const isSelected =
            selectedCell &&
            selectedCell.row === rowIndex &&
            selectedCell.col === colIndex;
// ① Board'daki kalıcı harf veya preview
    const displayLetter =
      cell || (tempPosition?.row === rowIndex && tempPosition?.col === colIndex ? enteredLetter : '');

          return (
            <div
              data-bonus-cell={bonusGame&&isBonus(rowIndex,colIndex)?'true':undefined}
              data-joker-selected={jokerSelection?.from?.row===rowIndex&&jokerSelection?.from?.col===colIndex?'true':undefined}
              data-board-cell={`${rowIndex}:${colIndex}`}
              data-km-filled={Boolean(displayLetter)}
              data-valid-word={isValidWordCell && !isOwnLetterDraftCell ? 'true' : undefined}
              key={`${rowIndex}-${colIndex}`}
              onClick={() => handleCellClick(rowIndex, colIndex)}
              style={{
                fontSize: largeLetters ? (board.length === 5 ? '3rem' : board.length === 7 ? '2.25rem' : board.length === 9 ? '1.875rem' : '1.5rem') : undefined,
                borderColor: isValidWordCell ? '#22c55e' : isCommittedLetterCell ? '#ef4444' : undefined,
                borderWidth: isValidWordCell || isCommittedLetterCell ? '2px' : undefined
              }}
              className={`
  aspect-square ${isOwnLetterDraftCell ? 'own-letter-draft-cell' : ''}
  w-full
  border border-slate-300 rounded-lg
  flex items-center justify-center 
  font-bold ${board.length === 5 ? 'text-4xl' : board.length === 7 ? 'text-3xl' : board.length === 9 ? 'text-2xl' : 'text-xl'}
  cursor-pointer transition-all duration-150
  ${cell ? 'bg-amber-100 text-slate-900' : 'bg-slate-50 text-slate-600'}
  ${isValidWordCell ? 'border-2 border-green-500' : isCommittedLetterCell ? 'border-2 border-red-500' : ''}
  ${isSelected ? 'ring-2 ring-yellow-300' : ''}
  hover:bg-yellow-100
  overflow-hidden
  leading-none
  text-center
`}
 >
              {bonusGame&&isBonus(rowIndex,colIndex)&&<BonusMark compact={Boolean(displayLetter)}/>}
              <span className="cell-letter-r41">{displayLetter}</span>
            </div>
          );
        })
      )}
    </div>
  </div>
</div>
</div>



{/* 👉 Onayla Butonu tam buraya geliyor */}

</section>
<aside className="flex w-full flex-col items-center min-[900px]:rounded-[2rem] min-[900px]:border min-[900px]:border-slate-200 min-[900px]:bg-white/80 min-[900px]:p-6 min-[900px]:shadow-xl min-[900px]:backdrop-blur-md">
  <div className="mb-4 hidden text-center min-[900px]:block">
    <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600">Hamle kontrolleri</p>
    <p className="mt-1 text-sm text-slate-500">Bir hücre seç, harfini gir ve hamleni onayla.</p>
  </div>


<div className="game-keyboard w-full shrink-0 flex flex-col items-center space-y-1">
 {[
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'Ğ', 'Ü'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Ş', 'İ'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M', 'Ö', 'Ç', '⌫']
  ].map((row, rowIndex) => (
    
    <div key={`row-${rowIndex}`}
  className="flex justify-center gap-[1px] sm:gap-[1px]">
   {row.map((letter, i) => {
    const isInactive = !connectionReady || confirmPending || ['Q', 'W', 'X'].includes(letter) || !isMyTurn || letterToPlace !== null || incomingMoveArmed || (letter === '⌫' && !tempPosition);
    if (letter === '⌫') return <button key={`delete-${rowIndex}`} type="button" className="game-key delete-key" aria-label="Onaylanmamış kendi harfini sil" disabled={isInactive} onClick={clearOwnDraft}><Delete size={20}/></button>;
    return (
        <button
          type="button" disabled={isInactive} aria-label={`${letter} harfi`}
          key={`letter-${rowIndex}-${i}`}
          ref={(el) => {
  if (el) letterRefs.current.push(el);
}}  // ⬅️ Bu kutuyu refs listesine ekliyoruz
  data-letter={letter}                       // ⬅️ Bu kutunun hangi harf olduğunu belirtiyoruz


          onClick={() => {
              if (!isInactive) handleLetterClick(letter);
            }}
            onTouchStart={(e) => {
    if (!isInactive) {
      const touch = e.touches[0];
      setPreviewLetter(letter);                                // Harfi göster
      setPreviewPosition({ x: touch.clientX, y: touch.clientY }); // Parmağın konumu
    }
  }}
  onTouchEnd={(e) => {
  const touch = e.changedTouches[0]; // 🟡 Parmağın bırakıldığı pozisyonu al
  setPreviewLetter(null); // 🟡 Önizlemeyi kaldır

  const hoveredLetter = letterRefs.current.find(el => {
    const rect = el.getBoundingClientRect();
    return (
      touch.clientX >= rect.left &&
      touch.clientX <= rect.right &&
      touch.clientY >= rect.top &&
      touch.clientY <= rect.bottom
    );
  });

  if (hoveredLetter) {
    const selected = hoveredLetter.getAttribute('data-letter');
    if (!['Q', 'W', 'X'].includes(selected) && isMyTurn && letterToPlace === null && !incomingMoveArmed) {
      e.preventDefault(); // Dokunmanın ardından ikinci bir sentetik click harfi yeniden seçmesin.
      handleLetterClick(selected); // 🟢 Bırakıldığında o harfi gerçek seçim yap
    }
  }
}}
  onTouchMove={(e) => {
  const touch = e.touches[0];
  setPreviewPosition({ x: touch.clientX, y: touch.clientY }); // ⬅️ Parmağın pozisyonunu güncelle
// ⬇️ Şu anki parmak konumunun altında bir harf kutusu var mı kontrol et
  const hoveredLetter = letterRefs.current.find(el => {
    const rect = el.getBoundingClientRect();
    return (
      touch.clientX >= rect.left &&
      touch.clientX <= rect.right &&
      touch.clientY >= rect.top &&
      touch.clientY <= rect.bottom
    );
  });

  // ⬇️ Eğer farklı bir harf altına geldiysek, önizleme harfini güncelle
  if (hoveredLetter) {
    const newLetter = hoveredLetter.getAttribute('data-letter');
    if (newLetter !== previewLetter && !['Q', 'W', 'X'].includes(newLetter)) {
      setPreviewLetter(newLetter);
    }
  }
}}
            className={`game-key
              w-[7.7vw] h-[8.7vw] max-h-10 sm:w-[6vw] sm:h-[7.6vw] md:w-[4.4vw] md:h-[6.2vw]
              flex items-center justify-center
              font-bold text-sm sm:text-base md:text-lg
              rounded-xl border transition-all duration-150 ease-in-out
              ${isInactive
                ? 'bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed'
                : `bg-white text-indigo-900 border-indigo-300 shadow cursor-pointer
                   ${(selectedLetter === letter || enteredLetter === letter) ? 'ring-2 ring-orange-400' : ''
                   }`
              }
            `}
          >
            {letter}
          </button>
          );
})}
</div>
))}
</div>
<div className={`game-actions mt-2 grid w-full max-w-[390px] ${humanChat ? 'grid-cols-2' : 'grid-cols-1'} gap-1.5 sm:mt-4 sm:gap-2 min-[900px]:max-w-none min-[900px]:grid-cols-2 min-[900px]:gap-3`}>

  <button
    title="Girdiğin harfi onayla"
    onClick={confirmOwnLetter}
    disabled={
    buttonsDisabled ||
  !selectedCell ||
  !enteredLetter ||
  !tempPosition
  }
    className={`game-confirm flex h-14 min-w-0 flex-col items-center justify-center rounded-xl px-1 font-semibold text-white transition-all duration-150 sm:h-16 min-[900px]:h-20
  ${buttonsDisabled || !selectedCell || !enteredLetter || !tempPosition
    ? 'bg-green-200 text-gray-400 cursor-not-allowed'
    : 'bg-green-700 hover:bg-green-800 active:scale-95 shadow-lg ring-4 ring-green-300 active:shadow-inner cursor-pointer'
  }`}
  >
    <Check className="w-5 h-5 sm:w-6 sm:h-6 mb-1" />
    <span className="text-sm font-black">Onayla</span>
  </button>
<button
  title="Rakipten gelen harfi pas geç"
  onClick={handleVoluntaryPass}
  disabled={!canPassIncomingLetter || !connectionReady || confirmPending}
  className={`flex h-14 min-w-0 flex-col items-center justify-center rounded-xl px-1 font-semibold transition-all duration-150 sm:h-16 min-[900px]:h-20
    ${!canPassIncomingLetter
      ? 'bg-blue-200 text-gray-400 cursor-not-allowed'
      : 'bg-blue-500 hover:bg-blue-600 active:scale-95 text-white shadow-md active:shadow-inner cursor-pointer'
    }`}
>
  <SkipForward className="w-5 h-5 sm:w-6 sm:h-6 mb-1" />
  <span className="text-xs font-semibold">Pas</span>
</button>
{humanChat && <GameChatButton unread={chat.unread} onClick={() => setChatOpen(true)} className="h-14 min-w-0 sm:h-16 min-[900px]:h-16 min-[1200px]:hidden" />}





</div>
{/* Mobilde klavye ile butonlar arasında boşluk bırakmak için görünmez boşluk */}
<div className="block h-1 min-[900px]:hidden" />


    </aside>
    {humanChat && wideChat && <div><GameChat messages={chat.messages} serverError={chat.error} username={username} opponent={opponentDisplayName} onSend={onChatSend} onRead={onChatRead} onReport={onChatReport} hasMore={chat.hasMore} onOlder={onChatOlder} /></div>}
    </main>
{ownProfileOpen&&<OpponentProfile username={username} target={username} displayName={ownDisplayName} image={fullProfileImage} onClose={()=>setOwnProfileOpen(false)}/> }
{opponentProfileOpen && <OpponentProfile username={username} target={opponentUsername} displayName={opponentDisplayName} image={fullOpponentImage} social={social} onFriendAction={onFriendAction} error={friendActionError} onClose={()=>setOpponentProfileOpen(false)}/>}
{jokerSelection?.to&&<SettingsDialog className="joker-confirm-r41" title="Harf Taşıma" onClose={()=>{if(!jokerPending)setJokerSelection(null);}}><p>Seçtiğin harf boş hücreye taşınacak. Onaylayınca envanterinden 1 joker eksilir.</p><div className="mt-4 flex gap-3"><button type="button" disabled={jokerPending} onClick={()=>setJokerSelection(null)}>Vazgeç</button><button type="button" disabled={jokerPending} onClick={()=>{if(!gameConnectionReady())return;const id=crypto.randomUUID();jokerRequest.current=id;setJokerPending(true);socket.send(JSON.stringify({type:'useMoveJoker',gameId:gameIdOverride,requestId:id,turnKey:joker.turnKey,from:jokerSelection.from,to:jokerSelection.to}));}}>{jokerPending?'Taşınıyor…':'1 joker kullan ve taşı'}</button></div></SettingsDialog>}
{forfeitOpen && <SettingsDialog className="kelimo-confirm-dialog" title="Pes et" onClose={() => setForfeitOpen(false)}><p>Bu maçtan çekilmek istiyor musun? Maç kayıp olarak sonuçlanır.</p><div className="mt-5 flex gap-3"><button type="button" className="rounded-lg border p-3" onClick={() => setForfeitOpen(false)}>Vazgeç</button><button type="button" className="rounded-lg bg-red-700 p-3 text-white" onClick={() => { if (!gameConnectionReady()) { setMessage('Bağlantı yok; yeniden bağlandıktan sonra dene.'); return; } socket.send(JSON.stringify({ type: 'forfeit' })); setForfeitOpen(false); setMessage('Oyundan çekildiniz.'); }}>Pes et</button></div></SettingsDialog>}
{humanChat && chatOpen && <div className="fixed inset-0 z-[80] flex items-end justify-center bg-slate-950/60 p-2 sm:items-center" onClick={event => { if (event.target === event.currentTarget) setChatOpen(false); }} onKeyDown={event => { if (event.key === 'Escape') setChatOpen(false); }}><GameChat mobile messages={chat.messages} serverError={chat.error} username={username} opponent={opponentDisplayName} onSend={onChatSend} onRead={onChatRead} onReport={onChatReport} hasMore={chat.hasMore} onOlder={onChatOlder} onClose={() => setChatOpen(false)} /></div>}
    

</div>
</>
);
}
